import { useState } from "react";
import { month_names } from "../../config";
import './Calendar.css'
import { usePracticesByDay } from "../../hooks/useALSE";

interface PracticesByDay {
    day: Date,
    count: number
}

function getClasses(actualDate: Date, date: Date, practices: Record<string, PracticesByDay>) {
    const today = new Date();
    const month = actualDate.getMonth()+1;
    const day = actualDate.getDate();
    const date_str = `${actualDate.getFullYear()}-${month < 10 ? '0'+month.toString() : month}-${day < 10 ? '0'+day.toString() : day}`
    const n = date_str in practices ? practices[date_str].count : 0;
    const isSameMonth = actualDate.getMonth() !== date.getMonth();

    return "day" + 
        (actualDate.getDate() === today.getDate() && actualDate.getMonth() === today.getMonth() && actualDate.getFullYear() === today.getFullYear() ? ' today' : '') +
        (isSameMonth ? ' mute' : '') +
        (!isSameMonth && n > 0 ? ' practice' : '') + 
        (!isSameMonth && n > 10 ? ' practice-' + (n > 25 ? '2' : '1') : '')
}

function addMonths(date: Date, months: number) {
    const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    newDate.setUTCMonth(newDate.getUTCMonth() + months);
    return newDate;
}

export default function Calendar() {
    const [date, setDate] = useState<Date>(new Date());
    const month = date.getMonth();
    const year = date.getFullYear();
    const {data: practices_by_day} = usePracticesByDay(date, [date]);
    const practices = (practices_by_day || []).reduce<Record<string, PracticesByDay>>((acc, item) => {
        acc[item.day.toString()] = item;
        return acc;
    }, {});

    const firstDate = new Date(year, month, 1);
    let weekDay = firstDate.getDay();
    weekDay = weekDay === 0 ? 7 : weekDay;
    firstDate.setDate(2 - weekDay);
    const firstDay = firstDate.getDate();

    let n_weeks = 6;

    return <div className="calendar btn">
        <div className="calendar-header">
            <button className="btn" onClick={() => setDate(addMonths(date, -1))}>{'<'}</button>
            <span className="header-text">
                {month_names[month][0].toUpperCase() + month_names[month].substring(1, 3) + ' ' + year.toString()}
            </span>
            <button className="btn" onClick={() => setDate(addMonths(date, 1))}>{'>'}</button>
        </div>
        {
            Array.from(Array(n_weeks)).map((_, week) =>
                <div className="week" key={week}>{
                    Array.from(Array(7)).map((_, day) => {
                        const actualDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDay);
                        actualDate.setDate(firstDay + 7*week + day)
                        return <div className={getClasses(actualDate, date, practices)} key={6 + 7*week + day}>
                            <div>{actualDate.getDate()}</div>
                        </div>
                    })
                }</div>
            )
        }
    </div>                               
}